import './theme.css';
import { setThemeColorByTheme, applyThemeClass, applyColorTheme } from './theme.js';
import { Outlet, useLocation } from "react-router-dom";
import Upperbar from './components/upperbar/upperbar.js';
import { AppContext } from './AppContext.js';
import { useState, useEffect } from "react";
import './locales/0_i18n.js'; // importa configuração de idiomas
// WEBSOCKET
import '../src/services/websocket.js'; // importa e inicia o websocket (deve ser aqui para que toda página que seja iniciada já com token ativo seja carregada corretamente)
import { addListener, removeListener } from '../src/services/eventBus.js';
import { GoDotFill } from "react-icons/go";



// SIMULAÇÃO STATUSBAR E NAVBAR SMARTPHONE (SOMENTE PARA DESENVOLVIMENTO)
// import { GoChevronLeft, GoGrabber , GoSquare  } from "react-icons/go";
// import { MdSignalWifiStatusbar3Bar, MdSignalCellularAlt  } from "react-icons/md";
// import { FaBatteryThreeQuarters } from "react-icons/fa6";



function App() {

  // WEBSOCKET-------------------------------------------------------------------------------------
  const [statusWs, setStatusWs] = useState(''); // status do cliente
  const [isApp, setIsApp] = useState(false); // estado para verificar se é app ou web



  // useEffect para verificar se é app ou web
  useEffect(() => {
    window.app = new URLSearchParams(window.location.search).get('app') === 'true' ||
      navigator.userAgent.includes('tSNotesApp');

    if (window.app) {
      setIsApp(true);
      localStorage.setItem('viaAcesso', 'app'); // Armazena a informação no localStorage
    } else {
      localStorage.setItem('viaAcesso', 'web'); // Armazena a informação no localStorage
      setIsApp(false);
    }
  }, []);



  // useEffect para receber mensagem do websocket
  useEffect(() => {
    const handleStatus = (msg) => {
      if (msg.type === 'ws-status') {
        switch (msg.status) {
          case 'connected':
            setStatusWs('connected')
            break;
          case 'disconnected':
            setStatusWs('disconnected')
            break;
          case 'error':
            setStatusWs('disconnected')
            break;
          case 'failed':
            setStatusWs('disconnected')
            break;
          default:
        }
      }
    };

    addListener(handleStatus);
    return () => removeListener(handleStatus);
  }, []);



  // CONFIGURAÇÕES DE TEMAS--------------------------------------------------------------------------
  const location = useLocation();
  const [searchTerm, setSearchTerm] = useState('');
  const isLoginPage = location.pathname !== "/notepad";

  useEffect(() => {
    function updateTheme() {
      applyThemeClass();
      applyColorTheme();
      // Só aplica na página notepad (não login, registro ou reset)
      if (!isLoginPage) {
        setThemeColorByTheme();
      } else {
        const theme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'theme-dark' : 'theme-light';
        const themeMeta = document.querySelector('meta[name="theme-color"]');
        if (!themeMeta) return;
        if (theme === 'theme-dark') {
          themeMeta.setAttribute('content', '#000');
        } else {
          // Busca a cor do tema claro definida no root CSS
          const lightThemeColor = getComputedStyle(document.documentElement).getPropertyValue('--ThemeBlue01').trim();
          themeMeta.setAttribute('content', lightThemeColor || '#2575fc');
        }
      }
    }
    updateTheme();

    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    mediaQuery.addEventListener('change', updateTheme);

    return () => {
      mediaQuery.removeEventListener('change', updateTheme);
    };
  }, [isLoginPage]);



  return (
    <AppContext.Provider value={{ isApp }}>
      <div className="App">
        <GoDotFill
          style={{
            position: 'fixed',
            top: isApp ? '30px' : '7px',
            right: '8px',
            fontSize: '0.4rem',
            zIndex: 1000,
            color: statusWs === 'connected' ? '#fff' : '#f54a4aff'
          }}
          title={`WebSocket status: ${statusWs}`}
        />

        {!isLoginPage && <Upperbar searchTerm={searchTerm} onSearch={setSearchTerm} />}
        <Outlet context={{ searchTerm }} />

        {
          /* 
            SOMENTE PARA DESENVOLVIMENTO (SIMULA A STATUSBAR E NAVBAR DO SMARTPHONE)
            OBS: DESCOMENTAR OS IMPORTS TAMBÉM NO INÍCIO DESTE ARQUIVO
          */
        }
        {/* <div className='simulationStatusbar'>
          <div className='statusbarTime'>12:45</div>
          <div className='statusbarIcons'>
            <div className='statusbarIcon'><MdSignalWifiStatusbar3Bar /></div>
            <div className='statusbarIcon'><MdSignalCellularAlt /></div>
            <div className='statusbarIcon'><FaBatteryThreeQuarters /></div>
          </div>
        </div>
        <div className='simulationNavbar'>
          <div className='navButton'><GoGrabber /></div>
          <div className='navButton'><GoSquare /></div>
          <div className='navButton'><GoChevronLeft  /></div>
        </div> */}
      </div>
    </AppContext.Provider>
  );
}

export default App;